import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Constants from "../utils/constants";
import React from "react";
import ClubOffers from "../components/ClubOffers";
import DeceasedAffiliate from "../components/DeceasedAffiliate";
import AffiliateConsultation from "../components/AffiliateConsultation";
import LastExpenses from "../components/LastExpenses";

const Pages = () => {
  return (
    <Router basename={'/clubamigos'}>
      <Routes>
        <Route path={Constants.APPURLS.OFFERS_CLUB} element={<ClubOffers />} />
        <Route
          path={Constants.APPURLS.LAST_EXPENSES}
          element={<LastExpenses />}
        />
        <Route
          path={Constants.APPURLS.AFFILIATE_CONSULTATION}
          element={<AffiliateConsultation />}
        />
        <Route
          path={Constants.APPURLS.DECEASED_AFFILIATE}
          element={<DeceasedAffiliate />}
        />

        <Route path="*" element={<ClubOffers />} />
      </Routes>
    </Router>
  );
};

export default Pages;
